export default __webpack_public_path__ + "img/temp10.asset.e54f43f3.jpg";